import { useState } from "react";
import "./Contact.css";
import { FaPhoneAlt, FaLock } from "react-icons/fa";

export default function Contact() {
  const [showForm, setShowForm] = useState(false);
  const [sending, setSending] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const toggleForm = () => {
    setShowForm(!showForm);
    setErrorMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setErrorMessage("");
    setMessageSent(false);

    const formData = Object.fromEntries(new FormData(e.target));

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(result.error || `Erreur serveur (${response.status})`);
      }

      setMessageSent(true);
      e.target.reset();
    } catch (err) {
      setErrorMessage(err.message || "Une erreur est survenue lors de l'envoi.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="section contact-section">
      <h2>Demander un devis personnalisé</h2>
      <p className="contact-subtitle">
        Étude gratuite et réponse confidentielle sous 24h ouvrées.
      </p>

      {/* Appel d'urgence direct */}
      <div className="urgent-call-box">
        <FaPhoneAlt className="urgent-phone-icon" />
        <div>
          <strong>Besoin d’une intervention urgente ou d’un gardiennage immédiat ?</strong>
          <p>
            Appelez directement notre permanence 24/7 au{" "}
            <a href="tel:+33602615612" className="urgent-tel-link">
              +33 6 02 61 56 12
            </a>
          </p>
        </div>
      </div>

      {!showForm && (
        <button onClick={toggleForm} className="btn-primary">
          Remplir le formulaire de devis en ligne
        </button>
      )}

      {messageSent && (
        <div className="alert-message success-msg">
          ✅ <strong>Demande reçue avec succès !</strong> Notre équipe opérationnelle analyse vos besoins et vous recontactera sous 24 heures.
        </div>
      )}

      {errorMessage && (
        <div className="alert-message error-msg">
          ⚠️ {errorMessage}
        </div>
      )}

      <div className={`contact-form-wrapper ${showForm ? "visible" : "hidden"}`}>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <input type="text" name="nom" placeholder="Votre nom *" required />
            <input type="text" name="prenom" placeholder="Votre prénom" />
          </div>

          <div className="form-row">
            <input type="text" name="entreprise" placeholder="Entreprise / Établissement (facultatif)" />
            <select name="prestation" defaultValue="" className="form-select" required>
              <option value="" disabled>Sélectionnez un service *</option>
              <option value="Agent Cynophile (Maître-chien)">Agent Cynophile (Maître-chien)</option>
              <option value="Sécurité Incendie (SSIAP)">Sécurité Incendie (SSIAP 1/2/3)</option>
              <option value="Surveillance Statique (ADS)">Agent de Prévention & Sécurité (ADS)</option>
              <option value="Sécurité Mobile & Rondes">Sécurité Mobile & Rondes d'intervention</option>
              <option value="Événementiel">Sécurité Événementielle</option>
              <option value="Autre">Autre prestation</option>
            </select>
          </div>

          <div className="form-row">
            <input type="email" name="email" placeholder="Adresse e-mail *" required />
            <input type="tel" name="telephone" placeholder="Numéro de téléphone *" required />
          </div>

          <div className="form-row">
            <input type="text" name="lieu" placeholder="Commune / Code postal d'intervention (ex: 78180)" />
            <select name="urgence" defaultValue="Sous 24h à 48h" className="form-select">
              <option value="Urgent (< 24h)">Délai : Urgent (moins de 24h)</option>
              <option value="Sous 24h à 48h">Délai : Sous 24h à 48h</option>
              <option value="Sous 1 mois">Délai : Sous 1 mois</option>
              <option value="Renseignement">Délai : Simple renseignement</option>
            </select>
          </div>

          <textarea
            name="message"
            placeholder="Précisez votre besoin (horaires souhaités, type de site : chantier, entrepôt, commerce, festival...) *"
            rows="4"
            required
          ></textarea>

          <p className="rgpd-notice">
            <FaLock className="rgpd-icon" /> Les informations transmises sont strictement confidentielles et utilisées uniquement pour élaborer votre proposition tarifaire.
          </p>

          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={sending}>
              {sending ? "Transmission en cours..." : "Envoyer ma demande de devis"}
            </button>
            <button type="button" onClick={toggleForm} className="btn-secondary">
              Masquer le formulaire
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
